import React from 'react';

const Placeholder = ({ width = '100%', height = '24px', borderRadius = '0', className= '' }) => {
  const style = {
    width: width,
    height: height,
    borderRadius: borderRadius,
    backgroundImage: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
    backgroundSize: "200% 100%",
    backgroundPosition: "200% 0",
    animation: "loading 1.5s infinite",
  };

  return <div style={style} className={className}></div>;
};

export default Placeholder;
